$(document).on('turbolinks:load', function() {

  // if($('.new-pitch, .new-final-video').length) {
  //   var submitted = false;
  //   $(window).on('beforeunload', function() {
  //     if(!submitted) {
  //       return confirm("If you leave now, your progress won't be saved?");
  //     }
  //   });
  //   $('.new-pitch, .new-final-video').on('submit', 'form', function() {
  //     submitted = true;
  //   });
  // }

  var video_play_ids = [];

  $(document).on('submit', '.video-upload-form', function() {
    $(this).addClass('loading');
    $('.video-upload-modal').addClass('visible');
    if($('.final-video-form').length) {
      $('#final_video_modal .close').hide();
      $('.final-video-form, .final-video-message').toggle();
    }
    $(this).find('input[type="submit"]').prop('disabled').prop('disabled', true);
  });

  $(document).on('submit', '.new-video-upload-form', function() {
    $(this).addClass('loading');
    $('.video-upload-modal').addClass('visible');
  });

  $(document).on('submit', '.33-new-video-upload-form', function() {
    if (!$("div.tips-container").find("div.filename").hasClass('hidden')) {
      $(this).addClass('loading');
      $('.video-upload-modal').addClass('visible');
    }
  });

  $('#share-form').submit(function(event) {
    if($('#pitch_share_email').val().trim().length === 0 && $('#pitch_share_phone').val().trim().length === 0) {
      console.log("dsad");
      $('.contact-info-error').show();
      return false;
    } else {
      console.log("342342");
      $('.contact-info-error').hide();
      return true;
    }
  });

  $('.new-pitch, .new-final-video').on('change', '#pitch_talent_ids, #final_pitch_video_talent_ids', function() {
    let $button = $('.new-pitch .step-3 input.button, .new-final-video .step-1 .button');
    $(this).val().length ? $button.removeClass('disabled') : $button.addClass('disabled');
  });

  $('.new-pitch').on('click', '.step-1 .button', function() {

  });

  $('.new-pitch #pitch_talent_ids').trigger('change');
  $('.new-final-video #final_pitch_video_talent_ids').trigger('change');

  $('.new-pitch').on('change paste keyup', '#pitch_name, #pitch_goal', function() {
    let $button = $('.new-pitch .step-2 .button.next, .new-pitch .step-33 .button.next');
    ($('#pitch_name').val() && $('#pitch_goal').val()) ? $button.removeClass('disabled') : $button.addClass('disabled');
  });

  $('.new-final-video').on('change paste keyup', '#final_pitch_video_title, #final_pitch_video_description', function() {
    let $button = $('.new-final-video .step-2 .button.next');
    ($('#final_pitch_video_title').val() && $('#final_pitch_video_description').val()) ? $button.removeClass('disabled') : $button.addClass('disabled');
  });

  $('.new-pitch #pitch_name').trigger('change');

   $('.new-pitch').on('change paste keyup', '#pitch_goal_amount', function() {
    let $button = $('.new-pitch .step-2 .button');
    ($('#pitch_goal_amount').val()) ? $button.removeClass('disabled') : $button.addClass('disabled');
  });

   $('.new-pitch #pitch_goal_amount').trigger('change');

  // $('.new-pitch, .new-final-video').on('change', '#pitch_video, #final_pitch_video_video', function(e) {
  //   let $button = $('.new-pitch .step-4 .button, .new-final-video input[type="submit"]');
  //   $button.trigger('click');
  //   $button.addClass('disabled');
  //   //$('.video-upload-form').addClass('loading');
  //   // $('.video-title').text(e.target.files[0].name);
  //   // $('.file-upload-link').html('Change Video');
  //   // $('#pitch_video').val() ? $button.removeClass('disabled') : $button.addClass('disabled');
  // });

  $('.new-pitch, .new-final-video').on('change', '#pitch_video, #final_pitch_video_video', function(e) {
    if ($('.new-pitch .step-33 .button').length){
      update_log_step()
    }
    else if ($('.new-pitch .step-2').length || $('.new-pitch .step-4').length || $('.new-pitch .new-video-upload-form').length) {
      e.preventDefault();
      if ($('.video-upload-modal').length) {
        $('.video-upload-modal').addClass('visible');
      }
      $(this).closest('form').trigger('submit');
    }
    else{
      let $button = $('.new-pitch .step-4 .button, .new-pitch .step-2 .button, .new-pitch .button, .new-final-video input[type="submit"]');
      $button.trigger('click');
      $button.addClass('disabled');
    }
  });

  function update_log_step(){
    let student_id = $('.new-pitch').data('student-id');
    let file_name = $('#pitch_video')[0].files[0].name
    url = '/students/' + student_id + '/pitches/log_step/video_selected';
    $.ajax({
      url: url,
      type: 'POST',
      data: {
        'filename': file_name
      }
    });
    $('div.filename').removeClass('hidden');
    $('div.filename label').text(file_name);
  }

  if($('.video-container select[multiple]').length && $('.video-container select[multiple]').next('.easyselect-container').length) {
    $('.video-container select[multiple]').next('.easyselect-container').remove();
  }
  $('.video-container select[multiple]').easySelect({
    removeIcon: '<span></span>'
  });

  if($('.new-pitch-container select[multiple]').length && $('.new-pitch-container select[multiple]').next('.easyselect-container').length) {
    $('.new-pitch-container select[multiple]').next('.easyselect-container').remove();
  }
  $('.new-pitch-container select[multiple]').easySelect({
    removeIcon: '<span></span>'
  });

  $('.video-container .easyselect-field, .new-pitch-container .easyselect-field').attr('placeholder', 'Search *');

  var new_pitch_step = 4;

  $('.new-pitch, .new-final-video').on('click', '.navigation', function(e) {
    e.preventDefault();
    if($(this).hasClass('disabled')) return;
    let student_id = $('.new-pitch').data('student-id');

    if(new_pitch_step == 1) {
      url = '/students/' + student_id + '/pitches/log_step/talents_set';
      $.ajax({
        url: url,
        type: 'POST',
        data: {
          'talents': $('#pitch_talent_ids').val()
        }
      });
    }

    if(new_pitch_step == 2) {
      url = '/students/' + student_id + '/pitches/log_step/name_goal_set';
      $.ajax({
        url: url,
        type: 'POST',
        data: {
          'name': $('#pitch_name').val(),
          'goal': $('#pitch_goal').val()
        }
      });
    }

    if(new_pitch_step == 3) {
      url = '/students/' + student_id + '/pitches/log_step/goal_amount_set';
      $.ajax({
        url: url,
        type: 'POST',
        data: {
          'goal_amount': $('#pitch_goal_amount').val()
        }
      });
    }

    if(new_pitch_step == 4) {
      let student_id = $('.new-pitch').data('student-id');
      url = '/students/' + student_id + '/pitches/log_step/video_selected';
      $.ajax({
        url: url,
        type: 'POST',
        data: {
          'filename': $('#pitch_video')[0].files[0].name
        }
      });
    }

    $('.new-pitch .step-' + new_pitch_step + ', .new-final-video .step-' + new_pitch_step).hide();
    $(this).hasClass('back') ? new_pitch_step-- : new_pitch_step++;
    let $new_screen = $('.new-pitch .step-' + new_pitch_step + ', .new-final-video .step-' + new_pitch_step);
    $new_screen.show();
  });

  $('.new-pitch, .new-final-video').on('click', '.new_navigation', function(e) {
    e.preventDefault();
    if($(this).hasClass('disabled')) return;
    let student_id = $('.new-pitch').data('student-id');
    url = '/students/' + student_id + '/pitches/log_step/video_selected';
    $.ajax({
      url: url,
      type: 'POST',
      data: {
        'filename': $('#pitch_video')[0].files[0].name
      }
    });
    let $form = $('.new-pitch form')
    $form.submit();
  });

  $('.new-pitch, .new-final-video').on('click', '.talent-suggest-link', function(e){
    e.preventDefault();
    $('.suggest-talent').addClass('visible');
  });


  $('.new-pitch, .new-final-video').on('click', '.suggested-message span', function(e){
    e.preventDefault();
    $('.suggested-message').hide();
  });

  $('.publish-alert .button').on('click', function(e) {
    e.preventDefault();
    $('.publish-alert').hide();
    $('.student-pitch-page-content, .pitch-actions').removeClass('hidden');
  });

  $('.student-pitch-page').on('change', '#pitch_video', function(e) {
    var $source = $('.video-sizer video');
    $source[0].src = URL.createObjectURL(e.target.files[0]);
    $source.parent()[0].load();
  });

  $('.student-update').on('change', '#student_update_video, #student_update_image', function(e) {
    var $object_container = $(this).closest('.object-container')
    if ($object_container.find('.object').length) {
      var $source = $object_container.find('.object');
      $source[0].src = URL.createObjectURL(e.target.files[0]);
      $source.parent()[0].load();
    } else {
      $object_container.find('.object-title').text(e.target.files[0].name);
    }
  });

  $('.student-pitch-page').on('click', '.video-container .edit-toggle, .form-container .cancel-edit', function(e) {
    e.preventDefault();
    $(this).closest('.video-container').toggleClass('editing');
  });

  $('.widdyup-video-page').on('click', '.edit-toggle, .cancel-edit', function(e) {
    e.preventDefault();
    $(this).closest('.video-container').toggleClass('editing');

    if ($(this).attr('class').includes("edit-toggle")) {
      $(".form-element").removeClass('hidden');
      $(".form-element .form-actions").removeClass('hidden');
    } else {
      $(".form-element").addClass('hidden');
    }
  });

  $('.flag-link, .flag-trigger').on('click', function(e) {
    e.preventDefault();
    $('#flag_reason_modal').addClass('visible');
    $('#flag_reason_modal form').attr('action', $(this).attr('href'));
  });

  $(document).on('click', '#flag_reason_modal form input[type="submit"]', function(e) {
    if(!$('input[name="flag[reason]"]:checked').val()) {
      e.preventDefault();
      $('#flag_reason_modal .flag-reason-error').show();
    }
  });

  $(document).on('change', 'input[name="flag[reason]"]', function(e) {
    $('#flag_reason_modal .flag-reason-error').hide();
  });

  $(document).on('click', '.high-five-trigger', function(e) {
    e.preventDefault();
    $.get($(this).attr('href'));
    if($(this).hasClass('active')) {
      $(this).addClass('turned-off');
      $(this).mouseleave((function() { $(this).removeClass('turned-off') }));
    }
    $(this).toggleClass('active');
  });

  $(document).on('click', '.share-trigger', function(e) {
    e.preventDefault();
    $('#share_modal').addClass('visible');
    $('#share_modal form').attr('action', $(this).attr('href'));
    $('#share_modal form').find('input[type="email"], input[type="phone"]').val('');
    $('#share_modal .copy-link').attr('data-clipboard-text', $(this).data('fundraising-link'));
  });

  $(document).on('click', '.pitch-share-trigger', function(e) {
    e.preventDefault();
    $('#share_modal').addClass('visible');

    if(this.hasAttribute('data-description')) {
      $('#share_modal .send-description').text($(this).data('description'));
    }

    $('#share_modal form').attr('action', $(this).attr('href'));
    $('#share_modal form').find('input[type="email"], input[type="phone"]').val('');

    handleInputStates($(this).data('action'));
  });
  $(document).on('click', '.share-anyway', function(e) {
    e.preventDefault();
    $('#final_share_modal').removeClass('visible');
    $('#share_modal').addClass('visible');
    $('#share_modal form').attr('action', $(this).data('action'));
    $('#share_modal form').find('input[type="email"], input[type="phone"]').val('');
    $('#share_modal .copy-link').attr('data-clipboard-text', $(this).data('fundraising-link'));
  });
  $(document).on('click', '.cancel', function(e) {
    e.preventDefault();
    $('#final_share_modal').removeClass('visible');
    $('#share_modal').removeClass('visible');
  });

  $(document).on('change', '#share_modal input[type="radio"]', function(e) {
    handleInputStates($(this).val());
  });

  if($('.levels-container').length) {
    if(!$('.pie_progress svg').length) {
      $('.pie_progress').each(function() {
        let currency = $(this).hasClass('currency'),
          $number = $(this).find('.pie_progress__number'),
          display = $(this).data('display');

        $(this).asPieProgress({
          namespace: 'pie_progress',
          size: 216,
          barsize: 48,
          trackcolor: '#EAECEE',
          numberCallback: function(n) {
            var value = display;
            if (currency) {
              value = '$' + display;
            }
            $number.text(value);
          }
        });
      });
      $('.levels-container .pie_progress').asPieProgress('finish');
    }
  }

  $(document).on('click', '.final-video-trigger', function(e) {
    e.preventDefault();
    $('#final_video_modal').addClass('visible');
  });

  if($('#final_video_modal').length) {
    $('#final_video_modal').on('change', '#final_pitch_video_video', function(e) {
      $('.video-title').text(e.target.files[0].name);
      $('#final_video_modal .button').html('Change Video');
    });
    // if (isAdvancedUpload) {
    //   $('#final_video_modal form').addClass('has-advanced-upload');
    //   let $file_box = $('#final_video_modal form .box label');
    //   $file_box.on('drag dragstart dragend dragover dragenter dragleave drop', function(e) {
    //     e.preventDefault();
    //     e.stopPropagation();
    //   })
    //   .on('drop', function(e) {
    //     droppedFiles = e.originalEvent.dataTransfer.files;
    //   });
    // }

  }

  $('video.track').on('play', function() {
    if(!video_play_ids.includes($(this).data('pitch-id'))) {
      video_play_ids.push($(this).data('pitch-id'));
      $.get('/pitches/' + $(this).data('pitch-id') + '/log_video_play')
    }
  });

  $('.step-4').on('click', '.easycapsules', function(e) {
    e.preventDefault();
    if ($('#pitch_talent_ids').val().length > 0) {
      ar = $('#pitch_talent_ids').val().split(', ');
    } else {
      ar = [];
    }

    let value = $(this).attr("data-value");
    let $button = $('.new-pitch .step-3 input.button');
    if (ar.includes(value)){
      ar.splice(ar.indexOf(value), 1);
      $('#pitch_talent_ids').val(ar.join(", "));
      $(this).removeClass('bluecapsule');
    }
    else {
      $(this).addClass('bluecapsule');
      ar.push(value);

      $('#pitch_talent_ids').val(ar.join(", "))
    }
    if (ar.length>0){
      $button.removeClass('disabled');
    }
    else {
      $button.addClass('disabled');
    }
  });

  if ($('input#pitch_talent_ids').val()){
    let ar = $('#pitch_talent_ids').val().split(', ');
    $('.easycapsules').each(function() {
      let value = $(this).attr("data-value");
      if (ar.includes(value)){
        $(this).addClass('bluecapsule');
      }
    });
  }
  else{
    let $button = $('.new-pitch .step-3 input.button');
    $button.addClass('disabled');
  }

});

var handleInputStates = function(send_type) {
  if(send_type == 'email' || send_type == 'text') {
    $('.csv-field').hide().find('input').prop('disabled', true).prop('required', false);
    $('.email-field').show().find('input').prop('disabled', false);
    $('.email-field').find('.mdc-text-field').removeClass('mdc-text-field--disabled');

    $('.telephone-field').show().find('input').prop('disabled', false);
    $('.telephone-field').find('.mdc-text-field').removeClass('mdc-text-field--disabled');

    $('.first-name-field').show().find('input').prop('disabled', false).prop('required', true);
    $('.first-name-field').find('.mdc-text-field').removeClass('mdc-text-field--disabled');

    $('.last-name-field').show().find('input').prop('disabled', false).prop('required', true);
    $('.last-name-field').find('.mdc-text-field').removeClass('mdc-text-field--disabled');
  } else {
    $('.email-field').hide().find('input').prop('disabled', true).prop('required', false);
    $('.first-name-field').hide().find('input').prop('disabled', true).prop('required', false);
    $('.last-name-field').hide().find('input').prop('disabled', true).prop('required', false);
    $('.telephone-field').hide().find('input').prop('disabled', true).prop('required', false);
    $('.csv-field').show().find('input').prop('disabled', false).prop('required', true);
  }
};

var isAdvancedUpload = function() {
  var div = document.createElement('div');
  return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window;
};
